import buildAuthCallback from '../api/buildAuthCallback';

export const handleAuthRedirect = (interactionCode, state) => {
  const codeVerifier = sessionStorage.getItem('verifier');
  const redirectUri = buildAuthCallback(interactionCode, state, codeVerifier);
  window.location.replace(redirectUri);
};

export default handleAuthRedirect;
